import { render } from "./WeekCycles.vue?vue&type=template&id=dae21ab2"
import script from "./WeekCycles.vue?vue&type=script&lang=js"
export * from "./WeekCycles.vue?vue&type=script&lang=js"

import "./WeekCycles.vue?vue&type=style&index=0&id=dae21ab2&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__